import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import { AuthProvider } from './context/AuthContext';

const msalInstance = new PublicClientApplication(msalConfig);


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Run a non-invasive, dev-only storage audit to gather evidence for scanner triage.
// This will not run in production builds.
if (process.env.NODE_ENV === 'development') {
  // Use dynamic import so the dev-only audit code is not bundled into production.
  import('./utils/storageAudit')
    .then((m) => {
      try {
        m.auditAuthTimestamps();
      } catch (e) {
        /* ignore */
      }
    })
    .catch(() => {
      /* ignore */
    });
}

root.render(
 <React.StrictMode>
   <AuthProvider>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </AuthProvider>
  </React.StrictMode>
);
